/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationMemberDataSchema = z.object({
	id: z.string(),
	email: z.string(),
	firstname: z.string().nullable(),
	lastname: z.string().nullable(),
	role: z.string().nullable(),
})

export type OrganisationMemberDataSchema = z.infer<typeof organisationMemberDataSchema>
